import { FC, SelectHTMLAttributes } from "react";
import styled from "styled-components";
import { DropDownArrow } from "../../shared/icons";
import { screenSizes } from "../../styles/theme";

const SelectContainer = styled.div`
  position: relative;
  min-width: 270px;
  @media (max-width: ${screenSizes.L}px) {
    margin-bottom: 10px;
  }
`;

const StyledSelect = styled.select<{ isLoading: boolean }>`
  width: 100%;
  max-width: 100%;
  padding: 10px 12px;
  appearance: none;
  background: rgba(9, 28, 0, 0.1);
  border: 1px solid rgba(9, 28, 0, 0.1);
  border-radius: 40px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(22, 22, 26, 0.6);
  outline: none;
  cursor: pointer;

  &:focus {
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }

  @media (max-width: 480px) {
    width: 100%;
    min-width: 150px;
    font-size: 12px;
  }
`;

const StyledOption = styled.option`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const DownArrow = styled.div`
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  pointer-events: none;

  svg {
    width: 10px;
    height: 10px;
    fill: #333;
  }
`;

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  options: { value: string | number; label: string }[];
  placeholder?: string;
  isLoading: boolean;
}

const CustomSelect: FC<SelectProps> = ({
  options,
  placeholder,
  isLoading,
  ...props
}) => {
  return (
    <SelectContainer>
      <StyledSelect isLoading {...props}>
        {placeholder && (
          <StyledOption value="" disabled selected hidden>
            {placeholder}
          </StyledOption>
        )}
        {options.map((option) => (
          <StyledOption key={option.value} value={option.value}>
            {option.label}
          </StyledOption>
        ))}
      </StyledSelect>
      <DownArrow>
        <DropDownArrow />
      </DownArrow>
    </SelectContainer>
  );
};

export default CustomSelect;
